<hugeicons-icon [size]="sizeMap[size]" [icon]="icon"></hugeicons-icon>
